import { useCallback, useEffect, useRef, useState } from 'react'
import Helmet from '../../../../components/Helmet'
import HeaderContent from '../../../../components/Layouts/HeaderContent'
import { ContentWrapper } from '../../../../components/ContentWrapper'
import { useNavigate } from 'react-router-dom'
import queryString from 'query-string'
import dayjs, { Dayjs } from 'dayjs'
import PageUrls from '../../../../constants/page-urls'
import { IFilterMapped } from '../../components/CommissionReportFilter'
import { Card, Grid } from '@mui/material'
import CommissionReportTable from './components/CommissionReportTable'
import useAxios from '../../../../hooks/useAxios'
import {
  IUserDailyReport,
  IUserOrderCancelledReport,
} from '../../../../types/report'
import * as XLSX from 'xlsx'
import { message } from 'antd'
import CommissionReportFilter from '../../components/CommissionReportFilter'

const Menus: any[] = []

const CommissionReportPage = () => {
  const navigate = useNavigate()

  const queryStr = queryString.parse(window.location.search)

  const tableRef = useRef(null)

  const [hideText, setHideText] = useState<boolean>(false)

  const [searchFilter, setSearchFilter] = useState<IFilterMapped>({
    categoryObjectIds: queryStr.categoryObjectIds?.length
      ? String(queryStr.categoryObjectIds).split(',')
      : undefined,
    productObjectIds: queryStr.productObjectIds?.length
      ? String(queryStr.productObjectIds).split(',')
      : undefined,
    productGroups: queryStr.productGroups?.length
      ? String(queryStr.productGroups).split(',')
      : undefined,
    distributionObjectIds: queryStr.distributionObjectIds?.length
      ? String(queryStr.distributionObjectIds).split(',')
      : undefined,
    startDate: queryStr.startDate
      ? dayjs(String(queryStr.startDate)).startOf('day').format()
      : dayjs().startOf('day').subtract(30, 'days').format(),
    endDate: queryStr.endDate
      ? dayjs(String(queryStr.endDate)).endOf('day').format()
      : dayjs().endOf('day').format(),
    isTelesale: queryStr.isTelesale ? (queryStr.isTelesale as string) : 'all',
    dateType: queryStr.dateType ? (queryStr.dateType as string) : 'orderDate',
    viewType: queryStr.viewType ? (queryStr.viewType as string) : 'sale',
    isCrm: queryStr.isCrm ? (queryStr.isCrm as string) : 'all',
  })
  const [filter, setFilter] = useState<IFilterMapped>({
    categoryObjectIds: queryStr.categoryObjectIds?.length
      ? String(queryStr.categoryObjectIds).split(',')
      : undefined,
    productObjectIds: queryStr.productObjectIds?.length
      ? String(queryStr.productObjectIds).split(',')
      : undefined,
    productGroups: queryStr.productGroups?.length
      ? String(queryStr.productGroups).split(',')
      : undefined,
    distributionObjectIds: queryStr.distributionObjectIds?.length
      ? String(queryStr.distributionObjectIds).split(',')
      : undefined,
    startDate: queryStr.startDate
      ? dayjs(String(queryStr.startDate)).startOf('day').format()
      : dayjs().startOf('day').subtract(30, 'days').format(),
    endDate: queryStr.endDate
      ? dayjs(String(queryStr.endDate)).endOf('day').format()
      : dayjs().endOf('day').format(),
    isTelesale: queryStr.isTelesale ? (queryStr.isTelesale as string) : 'all',
    dateType: queryStr.dateType ? (queryStr.dateType as string) : 'orderDate',
    viewType: queryStr.viewType ? (queryStr.viewType as string) : 'sale',
    isCrm: queryStr.isCrm ? (queryStr.isCrm as string) : 'all',
  })

  const onFilterChange = useCallback(
    (newFilter: IFilterMapped) => {
      setFilter(newFilter)
    },
    [setFilter],
  )

  const handleSearch = (newFilter: IFilterMapped) => {
    setFilter(newFilter)
    setSearchFilter(newFilter)
    const newQuery = queryString.stringify({ ...newFilter })
    navigate(`${PageUrls.Report.Commission}?${newQuery}`, {
      replace: true,
    })
  }

  useEffect(() => {
    handleSearch(filter)
  }, [])

  const { data, isLoading } = useAxios<IUserDailyReport[]>({
    method: 'GET',
    url: '/report/user-daily-reports',
    params: {
      ...searchFilter,
      isTelesale:
        searchFilter.isTelesale === 'all'
          ? undefined
          : searchFilter.isTelesale === 'telesale'
            ? true
            : false,
      type: 'order',
    },
  })

  //console.log('data', data)

  const userCancelledReport = useAxios<IUserOrderCancelledReport[]>({
    method: 'GET',
    url: '/report/order-cancelled-reports',
    params: {
      ...searchFilter,
      isTelesale:
        searchFilter.isTelesale === 'all'
          ? undefined
          : searchFilter.isTelesale === 'telesale'
            ? true
            : false,
      shippingProvider:
        searchFilter.shippingProvider === 'all'
          ? undefined
          : searchFilter.shippingProvider,
    },
  })

  const handleOnDownload = async (date: Dayjs) => {
    setHideText(true)

    if (tableRef.current) {
      setTimeout(() => {
        const ws = XLSX.utils.table_to_book(tableRef.current)
        const excelBuffer = XLSX.write(ws, { bookType: 'xlsx', type: 'array' })
        const data = new Blob([excelBuffer], {
          type: 'application/octet-stream',
        })

        const url = window.URL.createObjectURL(data)
        const link = document.createElement('a')
        link.href = url
        link.download = `comissionReport.xlsx`
        link.click()
        window.URL.revokeObjectURL(url)
        link.remove()
        message.success('ดาวน์โหลดสำเร็จ')
      }, 1000)
    }
    setTimeout(() => {
      setHideText(false)
    }, 1000)
  }

  return (
    <ContentWrapper>
      <Helmet title="รายงานคอมมิชชั่น" />
      <Grid container justifyContent="flex-start" alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title="รายงานคอมมิชชั่น"
            routes={Menus}
            descriptions="รายงานคอมมิชชั่น"
          />
        </Grid>
      </Grid>

      <Card
        sx={{
          padding: 2,
        }}
      >
        <CommissionReportFilter
          filter={filter}
          onFilterChange={onFilterChange}
          onSearch={handleSearch}
          showSippingProvider={false}
          onDownload={handleOnDownload}
        />
        <CommissionReportTable
          searchFilter={searchFilter}
          isLoading={isLoading || hideText}
          hideText={hideText}
          data={data}
          filter={filter}
          userCancelledReport={userCancelledReport.data}
          ref={tableRef}
        />
      </Card>
    </ContentWrapper>
  )
}

export default CommissionReportPage
